import { render, staticRenderFns } from "./ThgBillingCreditorSelection.vue?vue&type=template&id=5a5c9b0d&scoped=true&"
import script from "./ThgBillingCreditorSelection.vue?vue&type=script&lang=ts&"
export * from "./ThgBillingCreditorSelection.vue?vue&type=script&lang=ts&"
import style0 from "./ThgBillingCreditorSelection.vue?vue&type=style&index=0&id=5a5c9b0d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a5c9b0d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VIcon,VTooltip})
